import { Injectable } from "@angular/core";
import { HttpBackend, HttpClient, HttpEvent, HttpParams, HttpRequest } from "@angular/common/http";

import { environment } from '../../environments/environment';
import { Params } from "@angular/router";
import {catchError, map, tap, last} from "rxjs/operators";
import {Observable} from "rxjs";

@Injectable()
export class ApiService {

    constructor(private http: HttpClient, private httpBackend: HttpBackend) {}

    get(url: string, queryParamMap?: Params) {
        return this.http.get(environment.apiUrl + url, {params: queryParamMap});
    }

    post(url: string, data: any) {
        return this.http.post(environment.apiUrl + url, data);
    }

    postFile(url: string, data: FormData) : Observable<HttpEvent<HttpClient>>
    {
        let req = new HttpRequest('POST', environment.apiUrl + url, data, {
            reportProgress: true
        });

        return this.http.request(req);
    }

    postDownload(url: string, data: any) {
        return this.http.post(environment.apiUrl + url, data, {
            observe: 'response',
            responseType: 'arraybuffer'
        });
    }

    /**
     * Запрос к абсолютному URL
     * @returns {Observable<Object>}
     */
    getAbs(url: string, params = null) {
        if (environment.onlyLocalRequests) {
            return this.http.get(url, { params });
        } else {
            // Отключение intercept в url-запросах
            const plainHttpClient = new HttpClient(this.httpBackend);
            return plainHttpClient.get(url, { params: params });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/api.service.ts